import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ONE_PAGE_SECTIONS } from 'constants/businessToolSections/onePage';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { TextInputControl } from 'components/_basic/Form/TextInput';
import { FormHeader } from 'components/_basic/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';
import {
  EXECUTIVE_SUMMARY_MARKET_NAMES,
  prefix as executiveSummaryPrefix,
} from 'components/BusinessToolForm/Sections/ExecutiveSummary/MarketExecSummary/utils/form';
import { GLOBAL_FIELD_NAMES, globalPrefix } from 'components/BusinessToolForm/Sections/Global/form';

import { concatWithDot } from 'helpers/string';

export const MarketAndSales: React.FC = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const canAccess = useCheckSubSectionAccess(ONE_PAGE_SECTIONS.MARKET_AND_SALES);

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t('chapters.MARKET_AND_SALES')}
          section={ONE_PAGE_SECTIONS.MARKET_AND_SALES}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('executiveSummary.market.targetMarket')}
        aiFieldName={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.TARGET_MARKET)}
      >
        {/* 1.4.1 */}
        <TextInputControl
          multiline
          control={control}
          id="onePage.market.targetMarket"
          name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.TARGET_MARKET)}
          minRows={4}
          disabled={!canAccess}
          maxLength={1000}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('executiveSummary.market.dynamics')}
        aiFieldName={concatWithDot(executiveSummaryPrefix, EXECUTIVE_SUMMARY_MARKET_NAMES.DYNAMICS)}
      >
        {/* 1.4.2 */}
        <TextInputControl
          multiline
          control={control}
          id="onePage.market.dynamics"
          name={concatWithDot(executiveSummaryPrefix, EXECUTIVE_SUMMARY_MARKET_NAMES.DYNAMICS)}
          minRows={4}
          disabled={!canAccess}
          maxLength={1000}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('executiveSummary.market.mainCompetitors')}
        aiFieldName={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.MAIN_COMPETITORS)}
      >
        {/* 1.4.5 */}
        <TextInputControl
          multiline
          control={control}
          id="onePage.market.mainCompetitors"
          name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.MAIN_COMPETITORS)}
          minRows={4}
          disabled={!canAccess}
          maxLength={1000}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('executiveSummary.market.targetAudience')}
        aiFieldName={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.TARGET_AUDIENCE)}
      >
        {/* 1.4.3 */}
        <TextInputControl
          multiline
          control={control}
          id="onePage.market.targetAudience"
          name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.TARGET_AUDIENCE)}
          minRows={4}
          disabled={!canAccess}
          maxLength={1000}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('revenueStreamsAndKeyPartners')}
        aiFieldName={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.REVENUE_STREAMS)}
      >
        {/* 1.4.4 */}
        <TextInputControl
          multiline
          control={control}
          id="onePage.marketing.revenueStreams"
          name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.REVENUE_STREAMS)}
          minRows={4}
          disabled={!canAccess}
          maxLength={1000}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('marketingStrategyOutline')}
        aiFieldName={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.MARKETING_STRATEGY)}
      >
        {/* 1.4.4 */}
        <TextInputControl
          multiline
          control={control}
          id="onePage.market.marketingStrategy"
          name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.MARKETING_STRATEGY)}
          minRows={4}
          disabled={!canAccess}
          maxLength={1000}
        />
      </FormSectionCard>
    </>
  );
};
